export { usePaginationDots } from './usePaginationDots';
export type { SmartPaginationDotsProps } from './usePaginationDots';

export { PaginationDots } from './PaginationDots';

export { PaginationDot } from './PaginationDot';
export type { PaginationDotProps } from './PaginationDot';
